module.exports = __webpack_public_path__ + "static/media/fidelity.15aee13c.svg";